/* eslint-disable jsx-a11y/alt-text */
import React, { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import {
  Header,
  Nav,
  Content,
  List,
  SearchGroup,
  RadioFilters,
  OrderGroup,
  Container,
  ContainerBtn,
  PrevNext,
  AtualPage,
  LoadingContainer,
  HeaderActions
} from './styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  RootState,
  ADD_OCCURRENCES,
  ADD_STATES,
  ADD_REGIONS,
  ADD_CITIES,
  ADD_SOURCES,
  ADD_REASONS,
  ADD_CLIPPINGS,
  ADD_TRANSPORTS,
  ADD_NEIGHBORHOODS,
  ADD_QUALIFICATIONS,
  ADD_AGE_GROUP,
  ADD_GENRES,
  ADD_CIRCUMSTANCES,
  ADD_PLACES,
  ADD_ANIMALS,
  ADD_STATUS,
  ADD_POSITIONS,
  ADD_COORPORATIONS,
  ADD_SUBNEIGHBORHOODS,
  ADD_LOCALITIES
} from '../../store';
import {
  getStates,
  getRegions,
  getCities,
  getSourcers,
  getReasons,
  getClippings,
  getTransports,
  getNeighborhoods,
  getQualifications,
  getAgeGroup,
  getGenres,
  getCircumstances,
  getPositions,
  getCoorporations,
  getStatus,
  getAnimals,
  getPlaces,
  getOccurrencesByParams,
  getSubNeighborhoods,
  getLocalities,
  exportOccurrences
} from '../../services';
import {
  Button,
  ButtonSubline,
  CardOccurrence,
  SelectField,
  TextField
} from '../../components';
import OccurrenceChangesModal from '../../components/OccurrenceChangesModal';
import { RegisterForm, ModalReprovar } from './Modals/index';

import { learnMore } from '../../assets/index';
import RadioButon from '../../components/RadioButton';
import {
  convertOfTimestampsToDateTime,
  convertToDateAndHours
} from '../../utils/date';
import SocketContext from '../../context/socket';
import Loading from '../../components/Loading';
import { isDefined } from '../../utils/definedValue';
import { useNavigate } from 'react-router-dom';

enum OccurrenceScreenType {
  approveOccurrences,
  allOccurrences
}

interface OccurrenceFiltersStorage {
  occurrenceScreenType?: OccurrenceScreenType;
  order?: string;
  page?: number;
  take?: number;
  initial_date?: string;
  final_date?: string;
  search?: string;
  estado?: string;
  regiao?: string;
  cidade?: string;
  ordenacao?: string;
  circumstance?: string;
  qualification?: string;
  place?: string;
  typeOccurrences?: string;
}

interface IResultMetadata {
  total: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

const OCCURRENCES_FILTERS_STORAGE_KEY = '@cms/occurrences/list-filters';

const getStoredFilters = (): OccurrenceFiltersStorage => {
  if (typeof window === 'undefined') return {};

  try {
    const stored = sessionStorage.getItem(OCCURRENCES_FILTERS_STORAGE_KEY);
    return stored ? (JSON.parse(stored) as OccurrenceFiltersStorage) : {};
  } catch (error) {
    return {};
  }
};

const getDateValueForInput = (date?: string): string | undefined => {
  if (!date) return undefined;

  return date.includes('T') ? date.split('T')[0] : date;
};

const DEFAULT_INITIAL_DATE = '2000-01-01';

const getCurrentDateForInput = (): string => {
  const now = new Date();
  const timezoneOffsetInMs = now.getTimezoneOffset() * 60000;

  return new Date(now.getTime() - timezoneOffsetInMs)
    .toISOString()
    .split('T')[0];
};

const Occurrences: React.FC = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    user,
    token,
    occurrences,
    states,
    cities,
    circumstances,
    qualifications,
    places
  } = useSelector((state: RootState) => state.clickState);

  const { listOfOccurrences } = useContext(SocketContext);
  const [storedFilters] = useState<OccurrenceFiltersStorage>(() =>
    getStoredFilters()
  );
  const userFirstOccurrenceDateInState = getDateValueForInput(
    (user as any)?.first_occurrence_date_in_state
  );
  const defaultInitialDate =
    userFirstOccurrenceDateInState ?? DEFAULT_INITIAL_DATE;
  const defaultFinalDate = getCurrentDateForInput();
  const initialScreenType =
    storedFilters.occurrenceScreenType ===
      OccurrenceScreenType.allOccurrences ||
    storedFilters.occurrenceScreenType ===
      OccurrenceScreenType.approveOccurrences
      ? storedFilters.occurrenceScreenType
      : OccurrenceScreenType.approveOccurrences;
  const initialPage =
    typeof storedFilters.page === 'number' && storedFilters.page > 0
      ? storedFilters.page
      : 1;
  const initialTake =
    typeof storedFilters.take === 'number' && storedFilters.take > 0
      ? storedFilters.take
      : 50;
  const initialOrder =
    storedFilters.order === 'ASC' || storedFilters.order === 'DESC'
      ? storedFilters.order
      : 'DESC';
  const initialOrdenacao =
    storedFilters.ordenacao === 'dtoc' || storedFilters.ordenacao === 'dtc'
      ? storedFilters.ordenacao
      : 'dtc';
  const initialTypeOccurrences =
    initialScreenType === OccurrenceScreenType.approveOccurrences
      ? 'Waiting'
      : storedFilters.typeOccurrences;
  const [occurrenceScreenType, setOccurrenceScreenType] =
    useState<OccurrenceScreenType>(initialScreenType);

  const [isRegisterModal, setRegisterModal] = useState(false);
  const [estado, setEstado] = useState<any>(storedFilters.estado);
  const [regiao, setRegiao] = useState<any>(storedFilters.regiao);
  const [cidade, setCidade] = useState<any>(storedFilters.cidade);

  const [order, setOrder] = useState(initialOrder);
  const [page, setPage] = useState(initialPage);
  const [take, setTake] = useState(initialTake);

  const [initial_date, setInitialDate] = useState(
    storedFilters.initial_date ?? defaultInitialDate
  );
  const [final_date, setFinalDate] = useState(
    storedFilters.final_date ?? defaultFinalDate
  );
  const [search, setSearch] = useState(storedFilters.search ?? '');
  const [idOccorencia, setIdOcorrencia] = useState('');
  const [isAlterarStatusOcorrencia, setModalAlterarStatusOcorrencia] =
    useState(false);
  const [isAprove, setIsAprove] = useState(false);
  const [isReprovarOccorrencia, setModalReprovarOccorrencia] = useState(false);
  const [ocorrenciaTemp, setOccorenciaTemp] = useState<any>(null);
  const [ordenacao, setOrdenacao] = useState(initialOrdenacao);

  const [circumstance, setCircumstance] = useState(
    storedFilters.circumstance ?? ''
  );
  const [qualification, setQualification] = useState(
    storedFilters.qualification ?? ''
  );
  const [place, setPlace] = useState(storedFilters.place ?? '');

  const [typeOccurrences, setTypeOccurrences] = useState<any>(
    initialTypeOccurrences
  );

  const [resultMetada, setResultMetada] = useState<IResultMetadata>({
    total: 0,
    hasNextPage: false,
    hasPreviousPage: false
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [resetFiltersCounter, setResetFiltersCounter] = useState(0);
  const [isChangesModalOpen, setChangesModalOpen] = useState(false);
  const [selectedOccurrenceIdForChanges, setSelectedOccurrenceIdForChanges] =
    useState('');

  const handleResetFilters = () => {
    try {
      sessionStorage.removeItem(OCCURRENCES_FILTERS_STORAGE_KEY);
    } catch (error) {
      console.warn('(Ocorrencias) Erro ao limpar filtros salvos:', error);
    }

    setOrder('DESC');
    setPage(1);
    setTake(50);
    setInitialDate(defaultInitialDate);
    setFinalDate(getCurrentDateForInput());
    setSearch('');
    setEstado(undefined);
    setRegiao(undefined);
    setCidade(undefined);
    setOrdenacao('dtc');
    setCircumstance('');
    setQualification('');
    setPlace('');
    setTypeOccurrences(
      occurrenceScreenType === OccurrenceScreenType.approveOccurrences
        ? 'Waiting'
        : undefined
    );
    setResetFiltersCounter(prev => prev + 1);
  };

  function isNumeric(val: any) {
    return /^-?\d+$/.test(val);
  }

  function getOcorrencesByParams() {
    setIsLoading(true);

    let dt1 = undefined;
    let dt2 = undefined;

    if (initial_date !== '') {
      dt1 = initial_date + 'T00:00:00.000Z';
      dt2 = final_date + 'T23:59:59.000Z';
    } else {
      dt1 = '2000-01-01T00:00:00.000Z';
      dt2 = '2999-12-31T23:59:59.000Z';
    }

    let dt1_dtoc = undefined;
    let dt2_dtoc = undefined;
    let dt1_c = undefined;
    let dt2_c = undefined;

    if (ordenacao === 'dtoc') {
      dt1_dtoc = dt1;
      dt2_dtoc = dt2;
    } else if (ordenacao == 'dtc') {
      dt1_c = dt1;
      dt2_c = dt2;
    }

    getOccurrencesByParams(
      token,
      order,
      page,
      take,
      typeOccurrences,
      dt1_dtoc,
      dt2_dtoc,
      cidade?.length > 0 ? cidade : undefined,
      !isDefined(estado) ? (user as any)?.region?.id : undefined,
      isNumeric(search) === false && search?.length > 0 ? search : undefined,
      isNumeric(search) === true ? search : undefined,
      estado?.length > 1 ? estado : undefined,
      dt1_c,
      dt2_c,
      undefined,
      circumstance,
      qualification,
      place
    ).then(resp => {
      dispatch({
        type: ADD_OCCURRENCES,
        occurrences: resp.data
      });
      setResultMetada({
        total: resp.meta.itemCount,
        hasNextPage: resp.meta.hasNextPage,
        hasPreviousPage: resp.meta.hasPreviousPage
      });
      setIsLoading(false);
    });
  }

  useEffect(() => {
    getOcorrencesByParams();
  }, [
    typeOccurrences,
    initial_date,
    final_date,
    page,
    cidade,
    regiao,
    isRegisterModal,
    isReprovarOccorrencia,
    token,
    order,
    take,
    occurrenceScreenType,
    estado,
    dispatch,
    ordenacao,
    listOfOccurrences,
    circumstance,
    place,
    qualification,
    resetFiltersCounter
  ]);

  const list = ['Aprovar ocorrências', 'Todas as ocorrências'];
  const activeListItem =
    occurrenceScreenType === OccurrenceScreenType.allOccurrences
      ? list[1]
      : list[0];

  useEffect(() => {
    getRegions(token).then(resp => {
      dispatch({ type: ADD_REGIONS, regions: resp });
    });
    getStates(token).then(resp => {
      dispatch({ type: ADD_STATES, states: resp });
    });
    getCities(token).then(resp => {
      dispatch({ type: ADD_CITIES, cities: resp });
    });
    getSourcers(token).then(resp => {
      dispatch({ type: ADD_SOURCES, sources: resp });
    });
    getReasons(token).then(resp => {
      dispatch({ type: ADD_REASONS, reasons: resp });
    });
    getCircumstances(token).then(resp => {
      dispatch({ type: ADD_CIRCUMSTANCES, circumstances: resp });
    });
    getClippings(token).then(resp => {
      dispatch({ type: ADD_CLIPPINGS, clippings: resp });
    });
    getNeighborhoods(token).then(resp => {
      dispatch({ type: ADD_NEIGHBORHOODS, neighborhoods: resp });
    });
    getSubNeighborhoods(token).then(resp => {
      dispatch({ type: ADD_SUBNEIGHBORHOODS, subneighborhoods: resp });
    });
    getLocalities(token).then(resp => {
      dispatch({ type: ADD_LOCALITIES, localities: resp });
    });
    getStatus(token).then(resp => {
      dispatch({ type: ADD_STATUS, status: resp });
    });
    getQualifications(token).then(resp => {
      dispatch({ type: ADD_QUALIFICATIONS, qualifications: resp });
    });
    getTransports(token).then(resp => {
      dispatch({ type: ADD_TRANSPORTS, transports: resp });
    });
    getAnimals(token).then(resp => {
      dispatch({ type: ADD_ANIMALS, animals: resp });
    });
    getAgeGroup(token).then(resp => {
      dispatch({ type: ADD_AGE_GROUP, age_group: resp });
    });
    getGenres(token).then(resp => {
      dispatch({ type: ADD_GENRES, genres: resp });
    });
    getPlaces(token).then(resp => {
      dispatch({ type: ADD_PLACES, places: resp });
    });
    getPositions(token).then(resp => {
      dispatch({ type: ADD_POSITIONS, positions: resp });
    });
    getCoorporations(token).then(resp => {
      dispatch({ type: ADD_COORPORATIONS, coorporations: resp });
    });
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const storedData: OccurrenceFiltersStorage = {
      occurrenceScreenType,
      order,
      page,
      take,
      initial_date,
      final_date,
      search,
      estado,
      regiao,
      cidade,
      ordenacao,
      circumstance,
      qualification,
      place,
      typeOccurrences
    };

    try {
      sessionStorage.setItem(
        OCCURRENCES_FILTERS_STORAGE_KEY,
        JSON.stringify(storedData)
      );
    } catch (error) {
      return;
    }
  }, [
    occurrenceScreenType,
    order,
    page,
    take,
    initial_date,
    final_date,
    search,
    estado,
    regiao,
    cidade,
    ordenacao,
    circumstance,
    qualification,
    place,
    typeOccurrences
  ]);

  const getOccurrenceUserName = (occurrence: any) => {
    const defaultName = 'Desconhecido';
    let userName = occurrence?.user?.name || occurrence?.user?.nickname || '';

    return userName ? userName : defaultName;
  };

  const getOccurrenceAdminName = (occurrence: any) => {
    const defaultName = 'Desconhecido';
    let adminName =
      occurrence?.admin?.name || occurrence?.admin?.nickname || '';

    return adminName ? adminName : defaultName;
  };

  const handleExport = async () => {
    setIsExporting(true);

    let dt1 = undefined;
    let dt2 = undefined;

    if (initial_date !== '') {
      dt1 = initial_date + 'T00:00:00.000Z';
      dt2 = final_date + 'T23:59:59.000Z';
    } else {
      dt1 = '2000-01-01T00:00:00.000Z';
      dt2 = '2999-12-31T23:59:59.000Z';
    }

    let dt1_dtoc = undefined;
    let dt2_dtoc = undefined;
    let dt1_c = undefined;
    let dt2_c = undefined;

    if (ordenacao === 'dtoc') {
      dt1_dtoc = dt1;
      dt2_dtoc = dt2;
    } else if (ordenacao == 'dtc') {
      dt1_c = dt1;
      dt2_c = dt2;
    }

    try {
      const response = await exportOccurrences(token, {
        order,
        page,
        take,
        status: typeOccurrences,
        initial_date: dt1_dtoc,
        final_date: dt2_dtoc,
        city: cidade?.length > 0 ? cidade : undefined,
        region: !isDefined(estado) ? (user as any)?.region?.id : undefined,
        search:
          isNumeric(search) === false && search?.length > 0
            ? search
            : undefined,
        document_number: isNumeric(search) === true ? search : undefined,
        state: estado?.length > 1 ? estado : undefined,
        initial_date_create: dt1_c,
        final_date_create: dt2_c,
        circumstance,
        qualification,
        place
      });

      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'text/csv'
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      const downloadName = `occurrences-export-${new Date()
        .toISOString()
        .slice(0, 10)}.csv`;

      anchor.href = url;
      anchor.download = downloadName;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Exportacao iniciada.');
    } catch (error: any) {
      let message = 'Erro ao exportar ocorrencias.';
      const responseData = error?.response?.data;

      if (responseData instanceof Blob) {
        try {
          const text = await responseData.text();
          const parsed = JSON.parse(text);

          message = parsed?.message || parsed?.error || message;
        } catch (parseError) {
          console.warn('(Ocorrencias) Erro ao ler mensagem:', parseError);
        }
      } else {
        message = responseData?.message || responseData?.error || message;
      }

      toast.error(message);
      console.warn('(Ocorrencias) Erro ao exportar:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Container>
      <Header>
        <Nav>
          <ButtonSubline
            list={list}
            activeItem={activeListItem}
            onClick={() => {
              if (
                occurrenceScreenType === OccurrenceScreenType.allOccurrences
              ) {
                setOccurrenceScreenType(
                  OccurrenceScreenType.approveOccurrences
                );
                setTypeOccurrences('Waiting');
              } else {
                setOccurrenceScreenType(OccurrenceScreenType.allOccurrences);
                setTypeOccurrences(undefined);
              }
            }}
          />
        </Nav>
        <HeaderActions>
          <Button onClick={handleResetFilters} variant="outline" size="md">
            Limpar filtros
          </Button>
          <Button
            onClick={handleExport}
            variant="outline"
            size="md"
            disabled={isExporting}
          >
            {isExporting ? 'Exportando...' : 'Exportar CSV'}
          </Button>
          <Button
            data-cy="btn-register-occurence"
            onClick={() => navigate('/occurrences/create')}
            variant="secondary"
            size="md"
          >
            Registrar ocorrências
          </Button>
        </HeaderActions>
      </Header>
      <Content>
        <TextField
          label="Pesquisar"
          name="search"
          type="search"
          fieldSize="sm"
          value={search}
          onKeyDown={e => {
            if (e.key === 'Enter') getOcorrencesByParams();
          }}
          onChange={(e: any) => setSearch(e?.target?.value)}
          placeholder="Pesquisar"
        />

        <TextField
          label="Data Inicial"
          name="initial_date"
          type="date"
          fieldSize="sm"
          value={initial_date}
          onChange={(e: any) => {
            setInitialDate(e.target.value);
            setFinalDate(e.target.value);
          }}
        />

        <TextField
          label="Data Final"
          name="final_date"
          type="date"
          fieldSize="sm"
          value={final_date}
          onChange={(e: any) => {
            setFinalDate(e.target.value);
          }}
        />
        <SelectField
          label="Estado"
          name="state"
          fieldSize="sm"
          value={estado ?? ''}
          onChange={(e: any) => {
            setEstado(e?.target?.value);
          }}
        >
          <option value="">Selecione o estado</option>
          <option value=" ">Institucional</option>
          {states?.map((chave: any) => {
            return <option value={chave?.id}>{chave?.name}</option>;
          })}
        </SelectField>
        <SelectField
          label="Cidade"
          name="city"
          fieldSize="sm"
          value={cidade ?? ''}
          onChange={e => {
            setCidade(e.target.value);
          }}
          id="cidade"
          disabled={
            estado != undefined ? (estado?.length <= 0 ? true : false) : false
          }
        >
          <option value="">Selecione a cidade</option>
          {cities?.map((chave: any, valor: any) => {
            if (chave.state != null && chave.state.id === estado) {
              return <option value={chave.id}>{chave.name}</option>;
            }
          })}
        </SelectField>
      </Content>

      <Content>
        <SelectField
          label="Circunstância"
          name="circumstance"
          fieldSize="sm"
          value={circumstance}
          onChange={(e: any) => {
            setCircumstance(e?.target?.value);
          }}
        >
          <option value="">Circunstância</option>
          {circumstances?.map((chave: any) => {
            return <option value={chave?.id}>{chave?.name}</option>;
          })}
        </SelectField>

        <SelectField
          label="Qualificação"
          name="qualification"
          fieldSize="sm"
          value={qualification}
          onChange={(e: any) => {
            setQualification(e?.target?.value);
          }}
        >
          <option value="">Qualificação</option>
          {qualifications?.map((chave: any) => {
            return <option value={chave?.id}>{chave?.name}</option>;
          })}
        </SelectField>

        <SelectField
          label="Local"
          name="place"
          fieldSize="sm"
          value={place}
          onChange={(e: any) => {
            setPlace(e?.target?.value);
          }}
        >
          <option value="">Local</option>
          {places?.map((chave: any) => {
            return <option value={chave?.id}>{chave?.name}</option>;
          })}
        </SelectField>
      </Content>

      {occurrenceScreenType == OccurrenceScreenType.allOccurrences && (
        <SearchGroup>
          <RadioFilters>
            <div>
              <RadioButon
                id="todas"
                labelText="Todas"
                name="type_occurrences"
                value=""
                onChange={() => {
                  setTypeOccurrences(undefined);
                }}
                checked={typeOccurrences === undefined}
              />
            </div>
            <div>
              <RadioButon
                id="Waiting"
                labelText="Apenas aguardando aprovação"
                name="type_occurrences"
                value="Waiting"
                onChange={() => {
                  setTypeOccurrences('Waiting');
                }}
                checked={typeOccurrences === 'Waiting'}
              />
            </div>
            <div>
              <RadioButon
                id="Approved"
                labelText="Apenas aprovadas"
                name="type_occurrences"
                value="Approved"
                onChange={() => {
                  setTypeOccurrences('Approved');
                }}
                checked={typeOccurrences === 'Approved'}
              />
            </div>
            <div>
              <RadioButon
                id="Disapproved"
                labelText="Apenas reprovadas"
                name="type_occurrences"
                value="Disapproved"
                onChange={() => {
                  setTypeOccurrences('Disapproved');
                }}
                checked={typeOccurrences === 'Disapproved'}
              />
            </div>
          </RadioFilters>
          <OrderGroup>
            <SelectField
              label="Ordenar por"
              name="order_by"
              fieldSize="sm"
              onChange={(e: any) => {
                setOrdenacao(e.target.value);
              }}
            >
              <option value="dtc">Data da criação</option>
              <option value="dtoc">Data da ocorrência</option>
            </SelectField>
            <SelectField
              label="Direção"
              name="order_direction"
              fieldSize="sm"
              onChange={(e: any) => {
                setOrder(e.target.value);
              }}
            >
              <option value="DESC">Descendente</option>
              <option value="ASC">Ascendente</option>
            </SelectField>
          </OrderGroup>
        </SearchGroup>
      )}

      {isLoading ? (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      ) : (
        <>
          <List>
            <div>
              <p>Total encontrado: {resultMetada.total}</p>
              {!isDefined(estado) ? (
                <>
                  <h5>
                    Você está visualizando as ocorrências da sua região, caso
                    queira ver as ocorrências de outro estado selecione-o no
                    filtro.
                  </h5>
                  <br />
                </>
              ) : (
                <></>
              )}
            </div>
            {occurrenceScreenType == OccurrenceScreenType.allOccurrences ? (
              <>
                {occurrences?.map((occurrence: any, value) => {
                  return (
                    <CardOccurrence
                      id={occurrence.id}
                      document_number={occurrence.document_number}
                      status={occurrence.status}
                      user={getOccurrenceUserName(occurrence)}
                      admin={getOccurrenceAdminName(occurrence)}
                      date={convertToDateAndHours(occurrence.date)}
                      createdAt={convertOfTimestampsToDateTime(
                        occurrence.createdAt
                      )}
                      address={occurrence.address}
                      civiliansWounded={occurrence.number_civilians_wounded}
                      civiliansDead={occurrence.number_civilians_dead}
                      agentDead={occurrence.number_agent_dead}
                      agentWounded={occurrence.number_agent_wounded}
                      description={occurrence.description}
                      state={
                        occurrence.state === null ? '' : occurrence.state.name
                      }
                      aprove={() => {
                        switch (occurrence.status) {
                          case 'Waiting':
                            setRegisterModal(true);
                            setIdOcorrencia(occurrence.id);
                            setOccorenciaTemp(occurrence);
                            break;
                          case 'Approved':
                            setRegisterModal(true);
                            setIdOcorrencia(occurrence.id);
                            setOccorenciaTemp(occurrence);
                            break;
                          case 'Disapproved':
                            setRegisterModal(true);
                            setIdOcorrencia(occurrence.id);
                            setOccorenciaTemp(occurrence);
                            break;
                          default:
                            setRegisterModal(true);
                            setIdOcorrencia(occurrence.id);
                            setOccorenciaTemp(occurrence);
                        }
                      }}
                      reprove={() => {
                        if (occurrence.status === 'Waiting') {
                          setModalAlterarStatusOcorrencia(true);
                          setIdOcorrencia(occurrence.id);
                          setOccorenciaTemp(occurrence);
                        } else if (occurrence.status === 'Approved') {
                          setModalAlterarStatusOcorrencia(true);
                          setIdOcorrencia(occurrence.id);
                          setOccorenciaTemp(occurrence);
                        }
                      }}
                      changeStatus={() => {
                        setIsAprove(true);
                        setModalAlterarStatusOcorrencia(true);
                        setIdOcorrencia(occurrence.id);
                        setOccorenciaTemp(occurrence);
                      }}
                      onOpenChanges={() => {
                        setSelectedOccurrenceIdForChanges(occurrence.id);
                        setChangesModalOpen(true);
                      }}
                    />
                  );
                })}
              </>
            ) : (
              <>
                {occurrences?.map((occurrence: any, value) => {
                  if (occurrence.status === 'Waiting') {
                    return (
                      <CardOccurrence
                        key={occurrence.id}
                        id={occurrence.id}
                        document_number={occurrence.document_number}
                        status={occurrence.status}
                        user={getOccurrenceUserName(occurrence)}
                        admin={getOccurrenceAdminName(occurrence)}
                        date={convertToDateAndHours(occurrence.date)}
                        createdAt={convertOfTimestampsToDateTime(
                          occurrence.createdAt
                        )}
                        address={occurrence.address}
                        civiliansWounded={occurrence.number_civilians_wounded}
                        civiliansDead={occurrence.number_civilians_dead}
                        agentDead={occurrence.number_agent_dead}
                        agentWounded={occurrence.number_agent_wounded}
                        description={occurrence.description}
                        state={
                          occurrence.state === null ? '' : occurrence.state.name
                        }
                        aprove={() => {
                          switch (occurrence.status) {
                            case 'Waiting':
                              setRegisterModal(true);
                              setIdOcorrencia(occurrence.id);
                              setOccorenciaTemp(occurrence);
                              break;
                            case 'Approved':
                              setRegisterModal(true);
                              setIdOcorrencia(occurrence.id);
                              setOccorenciaTemp(occurrence);
                              break;
                            case 'Disapproved':
                              setRegisterModal(true);
                              setIdOcorrencia(occurrence.id);
                              setOccorenciaTemp(occurrence);
                              break;
                            default:
                              setRegisterModal(true);
                              setIdOcorrencia(occurrence.id);
                              setOccorenciaTemp(occurrence);
                          }
                        }}
                        reprove={() => {
                          if (occurrence.status === 'Waiting') {
                            setModalAlterarStatusOcorrencia(true);
                            setIdOcorrencia(occurrence.id);
                            setOccorenciaTemp(occurrence);
                          } else if (occurrence.status === 'Approved') {
                            setModalAlterarStatusOcorrencia(true);
                            setIdOcorrencia(occurrence.id);
                            setOccorenciaTemp(occurrence);
                          }
                        }}
                        changeStatus={() => {
                          setIsAprove(true);
                          setModalAlterarStatusOcorrencia(true);
                          setIdOcorrencia(occurrence.id);
                          setOccorenciaTemp(occurrence);
                        }}
                        onOpenChanges={() => {
                          setSelectedOccurrenceIdForChanges(occurrence.id);
                          setChangesModalOpen(true);
                        }}
                      />
                    );
                  }
                })}
              </>
            )}
          </List>
        </>
      )}

      <ContainerBtn>
        <PrevNext
          to="prev"
          onClick={() => {
            if (resultMetada.hasPreviousPage && page > 1) {
              let cont = page - 1;
              setPage(cont);
            }
          }}
          disabled={!resultMetada.hasPreviousPage}
        >
          <img src={learnMore} alt="" />
        </PrevNext>
        <AtualPage>{page}</AtualPage>
        <PrevNext
          to="next"
          onClick={() => {
            if (resultMetada.hasNextPage) {
              let cont = page + 1;
              setPage(cont);
            }
          }}
          disabled={!resultMetada.hasNextPage}
        >
          <img src={learnMore} alt="" />
        </PrevNext>
      </ContainerBtn>

      <ModalReprovar
        open={isAlterarStatusOcorrencia}
        onClose={() => {
          setOccorenciaTemp(null);
          setModalAlterarStatusOcorrencia(false);
          setIsAprove(false);
        }}
        occurrence={ocorrenciaTemp}
        dataDt={{
          typeOccurrences: typeOccurrences,
          initial_date: initial_date,
          final_date: final_date,
          search: search,
          page: page,
          cidade: cidade,
          regiao: regiao,
          isRegisterModal: isRegisterModal,
          isReprovarOccorrencia: isReprovarOccorrencia,
          order: order,
          take: take,
          estado: estado,
          ordenacao: ordenacao
        }}
        isAproovedModel={isAprove}
      />

      <RegisterForm
        isModal={isRegisterModal}
        onHide={() => {
          setRegisterModal(false);
          setOccorenciaTemp(null);
        }}
        itemEdit={ocorrenciaTemp}
      />

      <OccurrenceChangesModal
        open={isChangesModalOpen}
        token={token}
        occurrenceId={selectedOccurrenceIdForChanges}
        onClose={() => {
          setChangesModalOpen(false);
          setSelectedOccurrenceIdForChanges('');
        }}
      />
    </Container>
  );
};

export default Occurrences;
